import React from "react";
import { useDispatch, useSelector } from "react-redux";
import DeviceContext from "../../../utils/indentifyDevice";
import DpTransactionDesk from "./DpTransactionDesk";
import DpTransactionMobile from "./DpTransactionMobile";
import loaderGIF from "../../../assets/images/Reports/loaderGIF.gif";
import ErrorNotification, { ErrorDisplayType, } from "../../../components/generic/error";
import di from "../HoldingReports/di/servicelocator";
import { HOLDING_HIDE_ERROR } from "@frameworks/web/redux/interfaces/Reports/iHoldingReport";
import { HoldingErrorEnum } from "@adapters/presenters/action-interfaces/Reports/HoldingReport";
import Errormsg from "../../../components/generic/errorMsg";
import { useNavigate, useParams } from "react-router-dom";
import { isLoginSourceEMT } from "@domains/utils/emtReportCallback";
import { getLoginSourceURL } from "@frameworks/web/utils/Navigate";
const DpTransactionTable = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loginOrigin } = useParams();
    const dpTransactionLoader = useSelector((state) => state.holdingReport.dpTransactionLoader);
    const dpTransHistoryErrorData = useSelector((state) => state.holdingReport.dpTransactionHistoryErrorData);
    const loginSource = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const emailStatus = useSelector((state) => state.holdingReport.emailStatus);
    const emptyValidation = useSelector((state) => state.holdingReport.emptyDpTransaction);
    const sendEmailReport = (dpIdRecord, email) => {
        let emailpayload;
        let downloadPayload;
        if (email) {
            emailpayload = {
                emailID: props.emailId,
                filePath: dpIdRecord.filePath,
            };
        }
        else {
            downloadPayload = {
                path: dpIdRecord.filePath,
            };
        }
        if (!isLoginSourceEMT(loginSource))
            props.setShowLoader(true);
        if (DeviceContext().isDesktop)
            props.setDpTransactionReport(true);
        props.setOperation("email_download");
        di.holdingReport.sendEmailForDPTransaction(emailpayload, downloadPayload);
        if (isLoginSourceEMT(loginSource)) {
            goBack();
        }
    };
    const goBack = () => {
        dispatch({
            type: HOLDING_HIDE_ERROR,
            errorType: HoldingErrorEnum.DOWNLOADSTATUS,
        });
        const destination = ".." + getLoginSourceURL(loginOrigin) + "?reportName=Holding";
        navigate(destination, { replace: true });
    };
    React.useEffect(() => {
        if (emailStatus.isOpen !== null && props.showLoader) {
            props.setShowLoader(false);
            if (emailStatus.isOpen === true) {
                props.setDownloadSuccess(true);
            }
            else {
                props.setDownloadFail(true);
            }
        }
    }, [emailStatus.isOpen]);
    return (React.createElement(React.Fragment, null,
        dpTransactionLoader && (React.createElement("img", { className: "loader  mx-auto d-block mt-4", src: loaderGIF, alt: "loaderGIF" })),
        !(dpTransHistoryErrorData === null || dpTransHistoryErrorData === void 0 ? void 0 : dpTransHistoryErrorData.isOpen) &&
            !dpTransactionLoader &&
            !(emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) && (React.createElement("div", null, DeviceContext().isDesktop ? (React.createElement(DpTransactionDesk, { dpTranactions: props.dpTranactions, sendEmailReport: sendEmailReport })) : (React.createElement(DpTransactionMobile, { dpTranactions: props.dpTranactions, sendEmailReport: sendEmailReport })))),
        React.createElement("div", { className: "mt-2" },
            dpTransHistoryErrorData.isOpen && (React.createElement(ErrorNotification, { error: dpTransHistoryErrorData.error, isOpen: dpTransHistoryErrorData.isOpen, displayType: ErrorDisplayType.INSECTION })),
            (emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon) && (React.createElement(Errormsg, { icon: emptyValidation === null || emptyValidation === void 0 ? void 0 : emptyValidation.icon, msg: emptyValidation.message })))));
};
export default DpTransactionTable;
